import {Drawer} from '@yandex-delivery/blocks/legacy'
import type {DrawerProps} from '@yandex-delivery/blocks/legacy/drawer/types'
import clsx from 'clsx'
import React from 'react'

import {classes} from './ModalDrawer.classes'

type Props = DrawerProps & {
  feedbackDrawer?: boolean
}

const ThemeModalDrawer: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
  feedbackDrawer,
  ...drawerProps
}) => {
  return (
    <Drawer
      {...drawerProps}
      className={clsx(classes.container, className)}
      data-theme-modal-drawer
      {...(feedbackDrawer ? {'data-feedback-drawer': true} : {})}
    >
      {children}
    </Drawer>
  )
}

export default ThemeModalDrawer
